import { render, staticRenderFns } from "./TableTop.vue?vue&type=template&id=2b215404&scoped=true&"
import script from "./TableTop.vue?vue&type=script&lang=js&"
export * from "./TableTop.vue?vue&type=script&lang=js&"
import style0 from "./TableTop.vue?vue&type=style&index=0&id=2b215404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b215404",
  null
  
)

export default component.exports